<template>
  <div class="visit-detail">
    <!-- 回访用药详情页 -->
    <van-cell-group inset class="cell-group">
      <div class="info_card">
        <van-row type="flex" gutter="20">
            <van-col span="12"><div class="info_item"><div class="label">患者姓名:</div> <div class="info_value">{{item.patient_name}}</div></div></van-col>
            <van-col span="12"><div class="info_item"> <div class="label">省份城市</div> <div class="info_value">{{item.province}}{{item.city}}</div></div></van-col>
        </van-row>
        <van-row type="flex" gutter="20">
            <van-col span="12"><div class="info_item"><div class="label">联系电话:</div> <div class="info_value">{{item.mobile}}</div></div></van-col>
            <van-col span="12"><div class="info_item"><div class="label">领药时间:</div> <div class="info_value">{{item.receive_date}}</div></div></van-col>
        </van-row>
        <van-row type="flex" gutter="20">
            <van-col span="12"><div class="info_item"><div class="label">领药阶段:</div> <div class="info_value">{{item.phase}}</div></div></van-col>
            <van-col span="12"><div class="info_item"><div class="label">领药次数:</div> <div class="info_value">{{item.receive_times}}</div></div></van-col>
        </van-row>
        <van-row type="flex" gutter="20">
            <van-col span="12"><div class="info_item"><div class="label">药房名称:</div> <div class="info_value">{{item.drugstore_name}}</div></div></van-col>
        </van-row>
      </div>
    </van-cell-group>

    <van-cell-group inset class="cell-group">
        <van-cell required title="回访时间" @click="chooseVisitDate()" is-link :value="visitDate" >
          <template> <div :style="{'color':visitDate=='请选择'?'#969799':'black'}">{{visitDate}}</div> </template>
        </van-cell>
        <van-cell required title="是否用药" @click="chooseIfUseDrug()" is-link :value="ifUseDrug" >
          <template> <div :style="{'color':ifUseDrug=='请选择'?'#969799':'black'}">{{ifUseDrug}}</div> </template>
        </van-cell>
        <van-cell v-if="ifUseDrug=='已用药'" required title="援助药品的用药时间" @click="chooseDrugUseTime()" is-link :value="drugDate" >
          <template> <div :style="{'color':drugDate=='请选择'?'#969799':'black'}">{{drugDate}}</div> </template>
        </van-cell>
        <van-field v-if="ifUseDrug=='已用药'" required v-model="infusionSite"  rows="2" autosize label="输注地点"  maxlength="50" type="textarea" placeholder="请输入输注地点" show-word-limit label-class="black-label"/>
        <van-cell v-if="ifUseDrug=='已用药'" >
          <template #title>
            <div >上传用药凭证</div>
            <image-uploader ref="imgUploader" :value="photoArr" @input="getPhoto" title=" " :num="9" @deleteCI="deleteCI" :sourceType="sourceType"></image-uploader>
          </template>
        </van-cell>
        <van-cell v-if="ifUseDrug=='未用药'" required title="未用药原因" @click="showNoUseReason=true" is-link :value="noUseReason" >
          <template> <div :style="{'color':noUseReason=='请选择'?'#969799':'black'}">{{noUseReason}}</div> </template>
        </van-cell>
        <van-field v-if="ifUseDrug=='未用药'&&noUseReason=='其他'" required v-model="otherReason"  rows="2" autosize label="其他原因" type="textarea" placeholder="请输入其他原因" show-word-limit label-class="black-label"/>
    </van-cell-group>

    <div style="margin:0 15px 15px 32px;color:red;font-size: 14px;" v-html="notice"></div>
    <div class="checkin-btn">
        <van-button type="primary" round color="#0AA8AF" @click="submit()" block :disabled="submitBtnDisabled">提交</van-button>
    </div>
    
    <!--选择回访时间-->
    <van-popup v-model="showVisitDatePicker" position="bottom" round> 
      <van-datetime-picker v-model="dateTime" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirmVisitDate" @cancel="cancelDate" />
    </van-popup>
    <!--选择是否用药-->
    <van-popup v-model="showDrugSatusPicker" position="bottom" round> 
      <van-picker show-toolbar :columns="drugSatusColumns" @confirm="onConfirmDrug" @cancel="onCancelDrug" />
    </van-popup>
    <!--已用药-援助药品的用药时间-->
    <van-popup v-model="showDrugTimePicker" position="bottom" round> 
      <van-datetime-picker v-model="drugTime" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirmDurgDate" @cancel="cancelDurgDate" />
    </van-popup>
    <!--未用药-未用药原因-->
    <van-popup v-model="showNoUseReason" position="bottom" round> 
      <van-picker show-toolbar :columns="noUseReasonColumns" @confirm="onConfirmReason" @cancel="onCancelReason" />
    </van-popup>


  </div>
</template>

<script>
import Vue from 'vue';
import { List,Divider,DropdownMenu, DropdownItem,Toast } from 'vant';
import ImageUploader from "@/views/publicWelfareStaff/ImageUploader";
import { mapState } from "vuex";
import { getPatientVist,createPatientVist,getPatientVistOptions } from '@/api/publicWelfareStaff';


Vue.use(Toast);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Divider);
Vue.use(List);
export default {
    components:{ImageUploader},
    data(){
        return {
            item:{},//包含以下全部信息的对象
            // name:"张三",
            // address:"湖北武汉",
            // mobile:"16644445555",
            // date:"2077-6-19",
            // phase:"77",
            // times:"77",
            // drugstore:"包治百病大药房",
            // useDrug:"是",

            //表单
            visitDate: "请选择", //回访时间
            showVisitDatePicker: false, //显示选择回访时间
            dateTime: new Date(), //回访时间对象
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(),

            ifUseDrug: "请选择", //是否用药
            showDrugSatusPicker: false, //显示选择是否用药
            drugSatusColumns:['已用药','延迟用药','未用药'],//用药状态

            //已用药
            drugDate: "请选择", //援助药品的用药时间
            drugTime: new Date(), //援助药品的用药时间对象
            showDrugTimePicker: false, //显示选择援助药品的用药时间
            infusionSite: "", //输注地点
            sourceType:['album', 'camera'],//图片上传源:拍照+相册
            photoArr:[],//上传用药凭证

            //未用药
            noUseReason:"请选择",//未用药原因
            showNoUseReason:false,//显示选择未用药原因
            noUseReasonColumns:[],
            otherReason:"",//其他原因


            receive_id:'',//随访id/领药id

            submitBtnDisabled:false,

        }
    },
    computed:{
      ...mapState(['publicWelfareStaff']),
        notice(){
            let str = ''
            if(this.ifUseDrug=='已用药'){
                str='请提醒患者下次领药材料和领药时间点；'
            }else if(this.ifUseDrug=='延迟用药'){
                str='1.请提醒患者注意药品存储要求，并且尽快用药；<br />2.下次仍需要对患者进行回访（5天内）；'
            }else if(this.ifUseDrug=='未用药'){
                str='请提醒患者药品退回到项目药房；'
            }
            return str
        }
    },   
    async created(){
      if(this.$route.query.receive_id)  this.receive_id=this.$route.query.receive_id

      await this.init()
      //   this.showPage=true;
    },
    methods: {
      async init(){
        await getPatientVist({receive_id:this.receive_id}).then(res=>{
          console.log("getPatientVist",res)

          this.item=res.data
          if(this.item) this.photoArr=this.item.images
          if(this.item.patient_vist){
            let data=this.item.patient_vist
            if(data.continue) this.ifUseDrug=data.continue
            if(data.vist_date) this.visitDate=data.vist_date
            if(data.other_reason) this.otherReason=data.other_reason
            if(data.empty_drug_reason) this.noUseReason=data.empty_drug_reason
            if(data.cyle_drug_use_date) this.drugDate=data.cyle_drug_use_date
            if(data.use_address) this.infusionSite=data.use_address
            
          }
        }).catch(error=>{
          Toast(err.response.data.message)
        })
        
        await getPatientVistOptions({receive_id:this.receive_id}).then(res=>{
          console.log("getPatientVistOptions",res)
          if(res.data){
            this.noUseReasonColumns=Object.keys(res.data)
          }
        }).catch(error=>{
          Toast(err.response.data.message)
        })
      },
      timeFormat(time) {
          let year = time.getFullYear();
          let month = time.getMonth() + 1;
          let day = time.getDate();
          return year + '-' + month + '-' + day;
      },
      cancelDurgDate() {
        // 取消选择援助药品的用药时间
        this.drugDate = "请选择"
        this.showDrugTimePicker = false
      },
      confirmDurgDate(drug_date) {
        // 确定选择援助药品的用药时间

        this.drugDate = this.timeFormat(drug_date)
        this.showDrugTimePicker = false
      },
      chooseDrugUseTime() {
        //援助药品的用药时间
        this.showDrugTimePicker = true
      },
      onCancelDrug() {
        // 取消是否用药
        this.ifUseDrug = "请选择"
        this.showDrugSatusPicker = false
      },
      onConfirmDrug(value, index) {
        // 确定是否用药值
        console.log("是否用药：",value)
        this.ifUseDrug = value
        this.showDrugSatusPicker = false
      },
      confirmVisitDate(date_value) {
        // 确定选择回访时间
        console.log("date_value",date_value)
        const d = new Date(date_value)
        let time = ''
        time = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
        console.log("time",time)
        this.visitDate = time
        this.showVisitDatePicker = false
      },
      cancelDate() {
        // 取消选择回访时间
        this.visitDate = "请选择"
        this.showVisitDatePicker = false
      },
      chooseVisitDate() {
        // 选择回访时间
        this.showVisitDatePicker = true
      },
      chooseIfUseDrug() {
        // 选择是否用药
        this.showDrugSatusPicker = true
      },

      onConfirmReason(value){
          this.noUseReason=value
          this.showNoUseReason=false
      },
      onCancelReason(){
          this.showNoUseReason=false
      },


        getPhoto(image){
            console.log("input-get",image)
        },
        deleteCI(){
            Dialog.confirm({
                message: '确定删除？',
            })
            .then(() => {
                this.photo=[]
            })
        },
        async submit(){
            // 新增记录
            console.log("提交")
            if(this.visitDate=="请选择"){
                Toast("请选择回访时间")
                return
            }
            if(this.ifUseDrug=="请选择"){
                Toast("请选择是否用药")
                return
            }

            let formdata={}
            formdata.visitDate=this.visitDate
            formdata.ifUseDrug=this.ifUseDrug
            if(this.ifUseDrug=='已用药'){
                if(this.drugDate=="请选择"){
                     Toast("请选择援助药品的用药时间")
                     return
                }
                if(!this.infusionSite){
                     Toast("请输入输注地点")
                     return
                }
                formdata.drugDate=this.drugDate
                formdata.infusionSite=this.infusionSite
                if(this.photoArr.length>0) formdata.photo=this.photoArr[0].src
            }else if(this.ifUseDrug=='未用药'){
                if(this.noUseReason=="请选择"){
                     Toast("请选择未用药原因")
                     return
                }
                if(!this.otherReason&&this.noUseReason=="其他"){
                     Toast("请输入其他原因")
                     return
                }
                formdata.noUseReason=this.noUseReason
                formdata.otherReason=this.otherReason
            }
            console.log("formdata",formdata)

            // if(data.continue) this.ifUseDrug=data.continue
            // if(data.vist_date) this.visitDate=data.vist_date
            // if(data.other_reason) this.otherReason=data.other_reason
            // if(data.empty_drug_reason) this.noUseReason=data.empty_drug_reason
            // if(data.cyle_drug_use_date) this.drugDate=data.cyle_drug_use_date
            // if(data.use_address) this.infusionSite=data.use_address
            let images_arr = []
            for(let i in this.photoArr){
                images_arr.push(this.photoArr[i].src)
            }
            let sendData={}
            if(this.ifUseDrug=="已用药"){
              sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                patient_id:this.item.patient_id,
                receive_id:this.item.receive_id,

                vist_date:this.visitDate,//回访时间
                continue:this.ifUseDrug,//是否用药
                //已用药
                cyle_drug_use_date:this.drugDate,//援助药品的用药时间
                use_address:this.infusionSite,//输注地点
                patient_vist_images:images_arr,//上传用药凭证
              }
            }else if(this.ifUseDrug=="延迟用药"){
              sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                patient_id:this.item.patient_id,
                receive_id:this.item.receive_id,

                vist_date:this.visitDate,//回访时间
                continue:this.ifUseDrug,//是否用药
                //延迟用药
              }
            }else if(this.ifUseDrug=="未用药"){
              sendData={
                volunteer_id:this.publicWelfareStaff.checkin_info.papid,
                patient_id:this.item.patient_id,
                receive_id:this.item.receive_id,

                vist_date:this.visitDate,//回访时间
                continue:this.ifUseDrug,//是否用药
                //未用药
                empty_drug_reason:this.noUseReason,//未用药原因
                other_reason:this.otherReason,//其他原因
              }
              if(this.noUseReason!="其他") delete sendData.other_reason
            }
            console.log("createPatientVist-发送数据",sendData)
            this.submitBtnDisabled=true
            await createPatientVist(sendData).then(res => {
              if(res.data){
                console.log("createPatientVist-返回数据",res.data)
                this.$router.replace({name:'staffMsg',query:{
                    title: "提交完成",
                    btnText: "返回用药回访页",
                    statusText: "回访完成",
                    notice:"",
                    route:'returnVisit',
                }})
              }
            })
            this.submitBtnDisabled=false


        }
    }
}
</script>

<style lang="scss" scoped>
.visit-detail{
    min-height: 100vh;
    background-color: #F9F9F9 ;
    font-size: 16px;
    padding-top: 15px;
    .checkin-btn {
        margin:  0 15px 15px 15px;
    }

    //回访信息卡片
    .van-cell-group {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    .cell-group{
        margin-bottom:10px;
        .info_card{
            padding:15px;
            .info_item{
                display: flex;
                flex-direction: column;
                margin-bottom: 10px;
                .label{
                    color: #848484;
                    font-size:14px;
                }
                .info_value{
                    color:#333333;
                    font-size: 15px;
                }
            }
        }
    }


    ::v-deep .black-label{
        span{
            color:#323233;
        }
    }
}
</style>